import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/config.js'
import { alert } from './modules/alert'
import { http } from './modules/http'
import { maps } from './modules/maps'
import { progress } from './modules/progress'
import { user } from './modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        alert,
        http,
        maps,
        progress,
        user,
        config: { state: config },
        rmSteps: {
            state: [{
                id: 1,
                icon: 'fa fa-users',
                iconComplete: 'fa fa-check',
                title: 'Step 1',
                url: '/risk/review'
            }, {
                id: 2,
                icon: 'fa fa-user-secret',
                iconComplete: 'fa fa-check',
                title: 'Step 2',
                url: '/risk/threats'
            }, {
                id: 3,
                icon: 'fa fa-thermometer-half',
                iconComplete: 'fa fa-check',
                title: 'Step 3',
                url: '/risk/level'
            }, {
                id: 4,
                icon: 'icon-compass',
                iconComplete: 'fa fa-check',
                title: 'Step 4',
                url: '/risk/report/'
            }, {
                id: 5,
                icon: 'fa fa-map',
                iconComplete: 'fa fa-check',
                title: 'Step 5',
                url: '/risk/plan'
            }, {
                id: 6,
                icon: 'fa fa-thumbs-o-up',
                iconComplete: 'fa fa-check',
                title: 'Step 6',
                url: '/risk/approve'
            }]
        }
    },
    strict: debug
})